import React from 'react';
import { Modal, Input, Form, Select, Checkbox, Button, Switch } from 'antd';
const { Option } = Select;
const InputGroup = Input.Group;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearchAutocomplete = async (value) => {
        const result = this.props.formValues.planesCuenta.filter(item => {
            return (item.cuentaContable + ' - ' + item.nombre).toUpperCase().match(value.toUpperCase());
        }).slice(0, 75);
        this.props.form.setFieldsValue({ planesCuentaAutocomplete: result });
    };

    handleChangeAutocomplete = (value) => {
        this.props.form.setFieldsValue({ idPlanCuentaVenta: value.key })
    }

    handleClearAutocomplete = () => {
        this.props.form.setFieldsValue({ idPlanCuentaVenta: undefined })
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    codigoReferencia: values.codigoReferencia,
                    idProductoSunat: values.idProductoSunat ? values.idProductoSunat.key : 0,
                    idPlanCuentaVenta: values.idPlanCuentaVenta ? values.idPlanCuentaVenta.key : 0,
                    flagIGVAfecto: values.flagIGVAfecto,
                    flagExonerado: values.flagExonerado,
                    flagISC: values.flagISC,
                    idImpuesto: values.idImpuesto ? values.idImpuesto.key : null,
                    flagRenta: values.flagRenta,

                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('planesCuentaAutocomplete', {
            initialValue: this.props.formValues.planesCuenta
                .filter(m => { return m.id === this.props.formValues.idPlanCuentaVenta })
        });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Servicio" : "Modificar Servicio"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Código referencia">
                                {getFieldDecorator('codigoReferencia', {
                                    initialValue: this.props.formValues.codigoReferencia
                                })(
                                    <Input
                                        placeholder="Ingresar Código Referencia"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Cuenta Contable Venta">
                                <InputGroup compact>
                                    {getFieldDecorator('idPlanCuentaVenta', {
                                        initialValue: this.props.formValues.idPlanCuentaVenta ? { key: this.props.formValues.idPlanCuentaVenta } : undefined
                                    })(
                                        <Select showSearch labelInValue
                                            style={{ width: `calc(100% - 40px)` }}
                                            placeholder={"Búsqueda de Cuenta Contable"}
                                            optionFilterProp="children"
                                            showArrow={false}
                                            onSearch={this.handleSearchAutocomplete}
                                        >
                                            {getFieldValue('planesCuentaAutocomplete').map(item => (
                                                <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                    <Button
                                        className="btn-autocomplete"
                                        style={{ width: '40px', fontSize: '14px' }}
                                        icon={this.props.form.getFieldValue('idPlanCuentaVenta') ? 'close' : 'search'}
                                        onClick={() => this.props.form.setFieldsValue({ idPlanCuentaVenta: undefined })}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Segmento (SUNAT)">
                                {getFieldDecorator('idSegmentoSunat', {
                                    initialValue: this.props.formValues.idSegmentoSunat ?
                                        { key: this.props.formValues.idSegmentoSunat } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Segmento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idFamiliaSunat: undefined, idClaseSunat: undefined, idProductoSunat: undefined });
                                            this.props.onChangeForm("idSegmentoSunat", option.key)
                                        }}
                                    >
                                        {this.props.formValues.segmentosSunat.map(item => (
                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Familia (SUNAT)">
                                {getFieldDecorator('idFamiliaSunat', {
                                    initialValue: this.props.formValues.idFamiliaSunat ?
                                        { key: this.props.formValues.idFamiliaSunat } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Familia"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idClaseSunat: undefined, idProductoSunat: undefined });
                                            this.props.onChangeForm("idFamiliaSunat", option.key)
                                        }}
                                    >
                                        {this.props.formValues.familiasSunat.map(item => (
                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Clase (SUNAT)">
                                {getFieldDecorator('idClaseSunat', {
                                    initialValue: this.props.formValues.idClaseSunat ?
                                        { key: this.props.formValues.idClaseSunat } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Clase"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idProductoSunat: undefined });
                                            this.props.onChangeForm("idClaseSunat", option.key)
                                        }}
                                    >
                                        {this.props.formValues.clasesSunat.map(item => (
                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Producto (SUNAT)">
                                {getFieldDecorator('idProductoSunat', {
                                    initialValue: this.props.formValues.idProductoSunat ?
                                        { key: this.props.formValues.idProductoSunat } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Producto"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.productosSunat.map(item => (
                                            <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9 form-group">
                            <Form.Item label="Tipo de afectación">
                                {getFieldDecorator('idImpuesto', {
                                    initialValue: this.props.formValues.idImpuesto ?
                                        { key: this.props.formValues.idImpuesto } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de afectación"}
                                        optionFilterProp="children"
                                    >
                                 
                                             {this.props.formValues.impuesto.map(item => (
                                                            ['10', '20', '30', '40'].includes(item?.codigoSunat?.trim()) ?
                                                                <Option key={item.id} value={item.id}>{item.nombre}</Option> :
                                                                null))}

                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Aplica Renta">
                                {getFieldDecorator('flagRenta', {
                                    initialValue: this.props.formValues.flagRenta,
                                    valuePropName: 'checked'
                                })(
                                    <Switch checkedChildren="SI" unCheckedChildren="NO"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        {/*             <div className="col-md-4 form-group">
                            <Form.Item label="IGV Afecto">
                                {getFieldDecorator('flagIGVAfecto', {
                                    initialValue: this.props.formValues.flagIGVAfecto,
                                    valuePropName: 'checked'
                                })(<Checkbox onChange={(e) => this.props.onChangeForm("flagIGVAfecto", e.target.checked, this.props.form)}></Checkbox>)}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Exonerado">
                                {getFieldDecorator('flagExonerado', {
                                    initialValue: this.props.formValues.flagExonerado,
                                    valuePropName: 'checked'
                                })(<Checkbox onChange={(e) => this.props.onChangeForm("flagExonerado", e.target.checked, this.props.form)}></Checkbox>)}
                            </Form.Item>
                        </div> */}
                        <div className="col-md-4 form-group" hidden={true}>
                            <Form.Item label="ISC">
                                {getFieldDecorator('flagISC', {
                                    initialValue: this.props.formValues.flagISC,
                                    valuePropName: 'checked'
                                })(
                                    <Switch checkedChildren="SI" unCheckedChildren="NO"
                                        onChange={(e) => this.props.onChangeForm("flagISC", e, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)